import { motion } from "framer-motion";

const STATS = [
  { value: "3", label: "Integrated Modules", color: "text-primary" },
  { value: "6+", label: "Compliance Frameworks", color: "text-on-surface dark:text-surface-bright" },
  { value: "24/7", label: "Continuous Monitoring", color: "text-secondary" },
  { value: "1", label: "Unified Risk View", color: "text-on-surface dark:text-surface-bright" },
];

export default function StatsStrip() {
  return (
    <motion.section
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.4 }}
      transition={{ duration: 0.5 }}
      className="w-full border-y border-glass bg-surface-container-low/50 dark:bg-white/5 py-8 mb-section-gap"
    >
      <div className="px-gutter max-w-container-max mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 divide-x divide-glass">
        {STATS.map((stat) => (
          <div key={stat.label} className="flex flex-col items-center text-center px-4">
            <span className={`font-data-mono text-[32px] font-bold mb-1 ${stat.color}`}>{stat.value}</span>
            <span className="font-label-sm text-label-sm text-on-surface-variant dark:text-surface-variant uppercase tracking-wide">
              {stat.label}
            </span>
          </div>
        ))}
      </div>
    </motion.section>
  );
}
